import cx from 'classnames';
import React from 'react';
import Rating from '../FeedbackRating';
import HTMLContent from '../HTMLContent';
import Title from './Title';
import { appendClassSuffix } from './utils';

var CampusBody = function CampusBody(_ref) {
  var body = _ref.body,
      title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: "dc-sct-feedback__campus-content"
  }, /*#__PURE__*/React.createElement(Title, {
    title: title
  }), /*#__PURE__*/React.createElement(HTMLContent, {
    className: "dc-sct-feedback__text",
    html: body,
    mathJaxEnabled: true
  }));
};

var Body = function Body(_ref2) {
  var body = _ref2.body,
      children = _ref2.children,
      isActive = _ref2.isActive,
      messageType = _ref2.messageType,
      rating = _ref2.rating,
      title = _ref2.title;
  if (!isActive) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('dc-sct-feedback__body', appendClassSuffix('dc-sct-feedback__body', messageType))
  }, /*#__PURE__*/React.createElement("div", {
    className: "dc-sct-feedback__content"
  }, children, title && body && /*#__PURE__*/React.createElement(CampusBody, {
    body: body,
    title: title
  })), rating && /*#__PURE__*/React.createElement(Rating, rating));
};

export default Body;